import React from 'react';
import {Node} from 'reactflow';

/**
 * Right sidepanel content for a default task schema node
 */
export default function DefaultTaskSchemaNodeDetailsSidepanelContent(props: {
  selectedNode: Node;
}): JSX.Element {
  return (
    <div>
      TODO REPLACE Displaying details for Node ID: {props.selectedNode.id}
      {/* TODO: Add actual node details here */}
    </div>
  );
}
